










// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';
import { Mixins } from 'vue-mixin-decorator';

// Third party
import dayjs, { UnitType } from 'dayjs';
import 'dayjs/locale/es';

// Constants
import Assets from '@/constants/assets.ts';
import RouteNames from '@/constants/route-names';

// Components
import Btn, {
  BtnColor,
  BtnWidth,
  BtnHeight,
  BtnFontSize,
  BtnPredefinedStyle,
} from '@/shared/components/btn.component.vue';
import Steps, {
  StepsContentSize,
} from '@/shared/components/steps.component.vue';
import SpotlightText, {
  SpotlightTextColor,
} from '@/shared/components/SpotlightText.component.vue';
import FieldSet from '@/shared/components/field-set.component.vue';
import Dropdown, {
  DropdownWidth,
  DropdownStyle
} from "@/shared/components/Dropdown.component.vue";
import ItemThumb, {
  ItemThumbPrefeginedStyle,
  TittleFontFamily,
  SubtitleFontFamily,
} from '@/shared/components/item-thumb.component.vue';

// Models
import { BudgetCommunicationStatus } from '@/manager/budget/models/budget.model';
import {
  BudgetPaymentMethod,
  BudgetPaymentStatus,
} from '@/manager/budget/models/budget.model';
import { Bill } from '@/clickbuy/purchase/models/bill.model';

// Views
import AcceptanceStart from '@/client/budget/views/acceptance/start/index.vue';
import Summary from '@/client/budget/views/acceptance/summary/index.vue';
import ChooseDelegation from '@/client/budget/views/acceptance/choose-delegation/index.vue';
import ChooseFees from '@/client/budget/views/acceptance/choose-fees/index.vue';
import FeesInfo from '@/client/budget/views/acceptance/fees-info/index.vue';
import ChoosePaymentMethod from '@/client/budget/views/acceptance/choose-payment-method/index.vue';
import DownloadView from '@/client/budget/views/acceptance/download-view/index.vue';
import InfoView from '@/client/budget/views/acceptance/info-view/index.vue';
import NotificationMessage from '@/shared/mixins/notificationMessage.mixin.ts';
import BillingData from '@/client/budget/views/acceptance/choose-payment-method/billing-data/index.vue';

import UtilsService from '@/core/services/utils.service';
import formatDate from "@/shared/filters/formatDate.filter.ts";


enum AcceptanceStep {
  // Start = 0,
  // Delegation = 1,
  Fees = 1,
  PaymentMethod = 1,
  Summary = 2,
}

interface MixinInterface extends Vue, NotificationMessage { }

@Component({
  components: {
    AcceptanceStart,
    Btn,
    ChooseDelegation,
    ChooseFees,
    ChoosePaymentMethod,
    DownloadView,
    Dropdown,
    FeesInfo,
    FieldSet,
    InfoView,
    ItemThumb,
    SpotlightText,
    Steps,
    Summary,
    BillingData
  },
  computed: {
    ...mapGetters({
      currentBudget: 'getCurrentBudgetAcceptance',
      getBudget: 'getBudget',
      hasServerError: 'hasServerError',
      getServerError: 'getServerError',
      isClientMainContainerColorWhite: 'isClientMainContainerColorWhite',
      isClientMainContainerColorGreyCustom:
        'isClientMainContainerColorGreyCustom',
      budgetIsExpired: 'currentBudgetAcceptanceIsExpired',
      getItineraryInfo: 'getCurrentBudgetAcceptanceMessageInfo',
      acceptanceFieldError: 'getAcceptanceFieldError',
      isCardMethodSelected: 'isCardMethodSelectedInCurrentBudgetAcceptance',
      isDirectDebitMethodSelected:
        'isDirectDebitMethodSelectedInCurrentBudgetAcceptance',
    }),
  },
  filters: {
    formatDate
  },
  methods: {
    ...mapActions({
      setCurrentBudgetAcceptance: 'setCurrentBudgetAcceptance',
      setClientMainContainerColorGreyCustom:
        'setClientMainContainerColorGreyCustom',
      setClientMainContainerColorWhite: 'setClientMainContainerColorWhite',
    }),
  },
})
export default class BudgetAcceptance extends Mixins<MixinInterface>(
  Vue,
  NotificationMessage
) {
  @Prop() private id!: string;
  @Prop({ default: '1' }) private step!: string;

  private assets = Assets;
  private btnColor = BtnColor;
  private btnPredefinedStyle = BtnPredefinedStyle;
  private btnWidth = BtnWidth;
  private btnHeight = BtnHeight;
  private btnFontSize = BtnFontSize;
  private spotlightTextColor = SpotlightTextColor;
  private itemThumbPrefeginedStyle = ItemThumbPrefeginedStyle;
  private tittleFontFamily = TittleFontFamily;
  private subtitleFontFamily = SubtitleFontFamily;
  private dropdownWidth = DropdownWidth;
  private DropdownStyle = DropdownStyle;
  private currentBudget!: any;
  private getBudget!: any;
  private setCurrentBudgetAcceptance!: any;
  private setClientMainContainerColorGreyCustom!: any;
  private setClientMainContainerColorWhite!: any;
  private isClientMainContainerColorWhite!: any;
  private isClientMainContainerColorGreyCustom!: any;
  private hasServerError!: any;
  private getServerError!: any;
  private budgetIsExpired!: any;
  private getItineraryInfo!: any;
  private acceptanceFieldError!: any;
  private budgetLoaded = false;
  private activeStep = this.step;
  private numberOfSteps = 2;
  private buttonContainerClass = '';
  private stepContentClass = StepsContentSize.Auto;
  private fieldError = false;
  private clientPayments: any
  private clientPaymentSelected: any = this.clientPayments ? this.clientPayments[0] : '';
  private previousPaymentMethod: any
  private editAddPaymentInfoBoolean: Boolean = false
  private showAddPaymentInfoBoolean: Boolean = false
  private newPaymentAdded: any = false
  private isCardMethodSelected: any
  private isDirectDebitMethodSelected: any
  private missingPaymentInfo: Boolean = false;
  private missingPaymentInfoMsg: any;

  @Watch('step')
  private watchStep(newVal: any, oldVal: any) {
    const isValid = this.checkStepValidation(newVal);
    if (!isValid) {
      this.goToStep(oldVal.toString());
    }
  }

  @Watch('activeStep')
  private watchActiveStep(newVal: any, oldVal: any) {
    this.checkStepValidation(newVal);
  }

  private created() {
    this.initializeComponent();
  }

  get hasMessageToShow() {
    return this.hasServerError || this.hastItineraryInfoMessage;
  }

  get messageToShow() {
    const message = {
      text: '',
      color: SpotlightTextColor.Error,
    };

    if (this.hasServerError) {
      message.text = this.getServerError;
    } else if (this.hastItineraryInfoMessage) {
      message.text = this.getItineraryInfo;
      message.color = SpotlightTextColor.Secondary;
    }

    return message;
  }

  get hastItineraryInfoMessage() {
    return this.getItineraryInfo !== '';
  }

  get showNextButton() {
    return this.step !== this.numberOfSteps.toString();
  }

  get currentStep() {
    let stepParsed = Number(this.step);
    if (isNaN(stepParsed)) {
      stepParsed = 0;
    }
    return stepParsed;
  }

  get showStart() {
    return false;
    // const result =
    //   this.budgetLoaded &&
    //   !this.showInfoView &&
    //   this.currentBudget.communicationStatus ===
    //     BudgetCommunicationStatus.Dispatched &&
    //   (this.step === undefined ||
    //     this.step === AcceptanceStep.Start.toString());
    // if (result && !this.isClientMainContainerColorGreyCustom) {
    //   this.setClientMainContainerColorGreyCustom();
    // }
    // return result;
  }

  get showSteps() {
    const result =
      this.budgetLoaded &&
      !this.showStart &&
      !this.showSummary &&
      !this.showDownloadView &&
      !this.showInfoView;
    if (result && !this.isClientMainContainerColorWhite) {
      this.setClientMainContainerColorWhite();
    }
    return result;
  }

  get showSummary() {
    const result =
      this.budgetLoaded &&
      (this.step !== undefined &&
        this.step === AcceptanceStep.Summary.toString()) &&
      !this.showDownloadView;
    if (result && !this.isClientMainContainerColorGreyCustom) {
      this.setClientMainContainerColorGreyCustom();
    }
    return result;
  }

  get showDownloadView() {
    const result =
      this.budgetLoaded &&
      this.currentBudget.communicationStatus ===
      BudgetCommunicationStatus.Accepted &&
      this.currentBudget.paymentStatus !== BudgetPaymentStatus.Cancelled;
    if (result && !this.isClientMainContainerColorGreyCustom) {
      this.setClientMainContainerColorGreyCustom();
    }
    return result;
  }

  get showInfoView() {
    return (
      this.budgetLoaded &&
      (this.currentBudget.paymentStatus === BudgetPaymentStatus.Cancelled ||
        this.currentBudget.communicationStatus ===
        BudgetCommunicationStatus.Rejected ||
        this.currentBudget.communicationStatus ===
        BudgetCommunicationStatus.Adjust ||
        this.currentBudget.communicationStatus ===
        BudgetCommunicationStatus.Pending ||
        (this.budgetIsExpired && !this.showDownloadView))
    );
  }

  private async initializeComponent() {
    this.checkStepValidation('1');
    this.fetchBudgetProducts();
    this.fetchBudgetProductsPack();
    this.fetchBudgetConvocations();
    await this.fetchBudget();
    await this.fetchAcquiredCourses();
    await this.fetchClientPayment(0);
    this.budgetLoaded = true;
    this.setCurrentBudgetAcceptance(this.getInitializedBudget());
  }

  private fetchBudget() {
    return this.$store.dispatch('fetchBudget', { id: this.id });
  }

  private fetchBudgetProducts() {
    return this.$store.dispatch('fetchBudgetProducts', { id: this.id });
  }

  private fetchBudgetProductsPack() {
    return this.$store.dispatch('fetchBudgetProductsPack', { id: this.id });
  }

  private fetchBudgetConvocations() {
    return this.$store.dispatch('fetchBudgetConvocations', { id: this.id });
  }

  private fetchAcquiredCourses() {
    return this.$store.dispatch('fetchAcquiredCoursesList', {
      id: this.getBudget(this.id).client.user.id,
    });
  }

  private getInitializedBudget() {
    const budget = Object.assign({}, this.getBudget(this.id));
    budget.paymentMethod = BudgetPaymentMethod.DirectDebit;
    this.$set(budget, 'bill', new Bill());
    return budget;
  }

  private checkButtonContainerClass() {
    let containerClass = '';
    let stepContentClassSelected!: StepsContentSize;
    // if (Number(this.activeStep) === 1) {
    //   containerClass = 'button-container--keep-bottom';
    //   stepContentClassSelected = StepsContentSize.Max;
    // } else {
    stepContentClassSelected = StepsContentSize.Auto;
    // }
    this.buttonContainerClass = containerClass;
    setTimeout(() => {
      this.stepContentClass = stepContentClassSelected;
    }, 500);
  }

  private goToStep(step: string) {
    this.$router.push({
      name: RouteNames.BudgetAcceptance,
      params: {
        id: this.id,
        step,
      },
    });
  }

  private back() {
    const previousStep = (Number(this.step) - 1).toString();
    this.checkButtonContainerClass();
    this.goToStep(previousStep.toString());
  }

  private next() {
    const nextStep = (Number(this.step) + 1).toString();
    this.billingDataFieldsValidation();
    this.checkStepValidation(nextStep);
  }

  private checkFormValidation(step: any) {
    if (step === AcceptanceStep.PaymentMethod.toString()) {
      this.fieldError = false;
      if (
        this.currentBudget.paymentMethod.toString() ===
        BudgetPaymentMethod.DirectDebit.toString()
      ) {
        return this.directDebitFieldsValidation();
      } else if (
        this.currentBudget.paymentMethod.toString() ===
        BudgetPaymentMethod.Card.toString()
      ) {
        return this.cardFieldsValidation();
      }
      // this.billingDataFieldsValidation();
    }
  }

  private checkStepValidation(step: any) {
    let valid = false;
    const stepToGo = step.toString();
    if (
      !(
        stepToGo === AcceptanceStep.PaymentMethod.toString() &&
        this.currentBudget.budgetFee.length === 0
      ) &&
      !(stepToGo === AcceptanceStep.Summary.toString() && this.fieldError) &&
      this.currentBudget.paymentMethod != undefined && (this.currentBudget.creditCard != undefined || this.currentBudget.bankAccount != undefined) &&
      !this.showAddPaymentInfoBoolean
    ) {
      this.checkButtonContainerClass();
      this.goToStep(stepToGo.toString());
      valid = true;
    }

    if ((stepToGo === AcceptanceStep.Summary.toString()) && !(this.currentBudget.paymentMethod != undefined && (this.currentBudget.creditCard != undefined || this.currentBudget.bankAccount != undefined))) {
      this.missingPaymentInfoMsg = "Bad Request: Faltan datos de pago aplazado. "
      this.missingPaymentInfo = true
      setTimeout(() => {
        this.missingPaymentInfo = false;
      }, 1500);
    }

    return valid;
  }

  get messageMissingPayment() {
    const message = {
      text: '',
      color: SpotlightTextColor.Error,
    };

    if (this.missingPaymentInfo) {
      message.text = this.missingPaymentInfoMsg;
      message.color = SpotlightTextColor.Secondary;
    }

    return message;
  }

  private directDebitFieldsValidation() {
    if (this.currentBudget.bankAccount) {
      const error: any = { bankAccount: {}, budgetSepaInfo: {} };
      const emptyField = 'Campo vacío';
      const errorField = 'Campo incorrecto';
      if (!(this.currentBudget.bankAccount as any).bank) {
        this.currentBudget.bankAccount.bank = "ec3215aa-a207-457a-865b-dca79c864263";
      }
      const bankNumber = (this.currentBudget.bankAccount as any).number;
      if (!bankNumber) {
        error.bankAccount['number'] = emptyField;
        this.fieldError = true;
      } else if (bankNumber.trim().length < 24) {
        error.bankAccount['number'] = errorField;
        this.fieldError = true;
      }
      if (!(this.currentBudget.bankAccount as any).holder) {
        error.bankAccount['holder'] = emptyField;
        this.fieldError = true;
      }
      if (!(this.currentBudget.bankAccount as any).number) {
        error.bankAccount['number'] = emptyField;
        this.fieldError = true;
      }
      // if (!(this.currentBudget.budgetSepaInfo as any).address) {
      //   error.budgetSepaInfo['address'] = emptyField;
      //   this.fieldError = true;
      // }
      // if (!(this.currentBudget.budgetSepaInfo as any).postalCode) {
      //   error.budgetSepaInfo['postalCode'] = emptyField;
      //   this.fieldError = true;
      // }
      // if (!(this.currentBudget.budgetSepaInfo as any).town) {
      //   error.budgetSepaInfo['town'] = emptyField;
      //   this.fieldError = true;
      // }
      // if (!(this.currentBudget.budgetSepaInfo as any).state) {
      //   error.budgetSepaInfo['state'] = emptyField;
      //   this.fieldError = true;
      // }

      if (this.fieldError) {
        this.setAcceptanceFieldError(error);
        return false
      } else {
        return true
      }
    }
  }

  private cardFieldsValidation() {
    if (this.currentBudget.creditCard) {
      const error: any = { creditCard: {} };
      const emptyField = 'Campo vacío';
      const errorField = 'Campo incorrecto';

      const cardNumber = (this.currentBudget.creditCard as any).number;
      if (!cardNumber) {
        error.creditCard['number'] = emptyField;
        this.fieldError = true;
      } else if (cardNumber.trim().length < 16) {
        error.creditCard['number'] = errorField;
        this.fieldError = true;
      }
      const dateExpiration = (this.currentBudget.creditCard as any)
        .dateExpiration;
      if (!dateExpiration) {
        error.creditCard['dateExpiration'] = emptyField;
        this.fieldError = true;
      } else if (dateExpiration.trim().length < 5) {
        error.creditCard['dateExpiration'] = errorField;
        this.fieldError = true;
      }
      const cvv = (this.currentBudget.creditCard as any).cvv;
      if (!cvv) {
        error.creditCard['cvv'] = emptyField;
        this.fieldError = true;
      } else if (cvv.trim().length < 3) {
        error.creditCard['cvv'] = errorField;
        this.fieldError = true;
      }
      if (!(this.currentBudget.creditCard as any).holder) {
        error.creditCard['holder'] = emptyField;
        this.fieldError = true;
      }

      if (this.fieldError || Object.keys(error.creditCard).length != 0) {
        this.setAcceptanceFieldError(error);
        return false
      } else {
        return true
      }
    }
  }

  private areFieldsEmpty(obj: any) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] !== "") {
        return false; // Si encuentra un campo no vacío, retorna false
      }
    }
    return true; // Si todos los campos están vacíos, retorna true
  }

  private billingDataFieldsValidation() {
    if (this.currentBudget.bill && !this.areFieldsEmpty(this.currentBudget.bill)) {
      const error: any = {};
      const emptyField = 'Campo vacío';
      const errorField = 'Campo incorrecto';

      if (!(this.currentBudget.bill as any).name) {
        error['name'] = emptyField;
        this.fieldError = true;
      }
      if (!(this.currentBudget.bill as any).email) {
        error['email'] = emptyField;
        this.fieldError = true;
      }
      if (!(this.currentBudget.bill as any).phone) {
        error['phone'] = emptyField;
        this.fieldError = true;
      }
      if (!(this.currentBudget.bill as any).nif) {
        error['nif'] = emptyField;
        this.fieldError = true;
      }
      if (!(this.currentBudget.bill as any).address) {
        error['address'] = emptyField;
        this.fieldError = true;
      }
      if (!(this.currentBudget.bill as any).postalCode) {
        error['postalCode'] = emptyField;
        this.fieldError = true;
      }
      if (!(this.currentBudget.bill as any).town) {
        error['town'] = emptyField;
        this.fieldError = true;
      }

      this.acceptanceFieldError['bill'] = error;
    }
  }

  private setAcceptanceFieldError(error: any) {
    const newError = error;
    this.$store.commit('setAcceptanceFieldError', newError);
  }

  @Watch("clientPaymentSelected")
  private watchClientPaymentSelected(newVal: any, oldVal: any) {
    this.showAddPaymentInfo(false)
    if (newVal && newVal.expiration) {
      this.currentBudget.bankAccount = undefined
      this.currentBudget.creditCard = newVal
      this.currentBudget.paymentMethod = BudgetPaymentMethod.Card
    } else {
      this.currentBudget.creditCard = undefined
      this.currentBudget.bankAccount = newVal
      this.currentBudget.paymentMethod = BudgetPaymentMethod.DirectDebit
    }

    this.setCurrentBudgetAcceptance(this.currentBudget)

  }


  private fetchClientPayment(viewStatus: number) {
    this.$store
      .dispatch("fetchClientPayment", { id: this.getBudget(this.id).client.user.id, viewStatus: viewStatus })
      .then((res) => {
        this.clientPayments = res.data.filter((item: any) => item.status != 1)
        this.clientPaymentSelected = this.clientPayments.filter((item: any) => item.active)[0]
        // this.setPreviousPaymentMethod()
        if (!this.clientPaymentSelected) {
          this.clientPaymentSelected = this.clientPayments[0]
        }
        if (res.info != '') {
          this.showNotification(res.info, SpotlightTextColor.Error);
        }
        this.$forceUpdate();
      });
  }

  // private setPreviousPaymentMethod() {
  //   let budget = this.getBudget(this.id)
  //   var clientPaymentId = budget.creditCard ? budget.creditCard.id : budget.bankAccount ? budget.bankAccount.id : undefined;
  //   if (this.clientPayments && clientPaymentId) {
  //     this.previousPaymentMethod = this.clientPayments.filter((item: any) => item.id == clientPaymentId)[0]
  //     this.$forceUpdate();
  //   }
  // }

  private setEditPaymentInfo(value: Boolean) {
    this.editAddPaymentInfoBoolean = value;
  }

  private showAddPaymentInfo(value: Boolean) {
    if (value == true) {
      this.currentBudget.creditCard = undefined
      this.currentBudget.bankAccount = undefined
      this.currentBudget.paymentMethod = undefined
    }
    this.showAddPaymentInfoBoolean = value;
  }

  private addPaymentInfo() {

    if (this.checkFormValidation(this.step)) {
      this.newPaymentAdded = true
      let errorNotification = null;
      let holder = null;

      if (this.isCardMethodSelected) {
        holder = this.currentBudget.creditCard.holder;
      } else if (this.isDirectDebitMethodSelected) {
        holder = this.currentBudget.bankAccount.holder;
      }

      if (holder && this.getBudget(this.id).client.user.fullName !== holder) {
        errorNotification = "El nombre del titular ha de ser igual al NOMBRE del cliente actual";
      }

      if (errorNotification) {
        this.showNotification(errorNotification, SpotlightTextColor.Error);
        this.newPaymentAdded = false
      } else {
        this.showAddPaymentInfo(false)
        this.$store
          .dispatch("newClientPayment", { id: this.getBudget(this.id).client.user.id, viewStatus: 0, ...this.getPaymentInfo() })
          .then((res) => {
            this.fetchClientPayment(0)
            this.showNotification(res.message);
            this.newPaymentAdded = false
          })
          .catch((err) => {
            this.showNotification(err.message, SpotlightTextColor.Error);
            this.newPaymentAdded = false
          });
      }
    }
  }

  private getPaymentInfo() {
    let info = {};
    let budget = this.getBudget(this.id)
    if (this.isCardMethodSelected) {
      info = { creditCard: this.creditCardFormated };
    } else if (this.isDirectDebitMethodSelected) {
      // const bankId = this.currentBudget.bankAccount.bank.id;
      // this.currentBudget.bankAccount.bank = bankId;
      if (process.env.VUE_APP_DEBUG) {
        // this.currentBudget.bankAccount.bank = "572a9108-f910-4cb6-942c-cedb529e29e3";
        this.currentBudget.bankAccount.bank = "ec3215aa-a207-457a-865b-dca79c864263";
      } else {
        // this.currentBudget.bankAccount.bank = "7591c2a8-691c-4862-aa57-fc374e9117a2";
        this.currentBudget.bankAccount.bank = "ec3215aa-a207-457a-865b-dca79c864263";
      }
      this.currentBudget.bankAccount.relatedProduct = budget.budgetLine.length > 0 && budget.budgetLine[0].product && budget.budgetLine[0].product.name ? budget.budgetLine[0].product.name : undefined
      info = { bankAccount: this.currentBudget.bankAccount };
    }
    return info;
  }

  get creditCardFormated() {
    let budget = this.getBudget(this.id)
    const creditCard = Object.assign({}, this.currentBudget.creditCard);
    const splittedDate = creditCard.dateExpiration.split('/');
    const month = Number(splittedDate[0]) - 1;

    let dateDayjs = dayjs();
    let year = dateDayjs.year().toString();
    year = year.substring(0, year.length - 2);
    year += splittedDate[1];
    dateDayjs = dateDayjs
      .set('date', 1)
      .set('month', month)
      .set('year', Number(year));
    creditCard.dateExpiration = dateDayjs.toISOString();
    creditCard.relatedProduct = budget.budgetLine.length > 0 && budget.budgetLine[0].product && budget.budgetLine[0].product.name ? budget.budgetLine[0].product.name : undefined
    return creditCard;
  }

  private copyHolderName() {
    if (this.currentBudget.paymentMethod.toString() ===
      BudgetPaymentMethod.DirectDebit.toString()) {
      this.currentBudget.bankAccount.holder = this.getBudget(this.id).client.user.fullName
    } else if (this.currentBudget.paymentMethod.toString() ===
      BudgetPaymentMethod.Card.toString()) {
      this.currentBudget.creditCard.holder = this.getBudget(this.id).client.user.fullName
    }

    this.setCurrentBudgetAcceptance(this.currentBudget)

    // Forzar refresco de los componentes hijos
    const choosePaymentMethodComponent = this.$refs.componentePagoAplazado as ChoosePaymentMethod
    if (choosePaymentMethodComponent.$children) {
      choosePaymentMethodComponent.$children.forEach((child: any) => {
        child.$forceUpdate()
      });
    }

  }


}
